import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    bindings: {
        classifiers: '='
    },
    template
})
export default class {
    constructor (lodash, DATATABLES, ListFactory, UserResource, SiteService, PrivilegeService, UserService,
                 ROLE_CODE_ENUM, ROLE_PRIVILEGE_ENUM, USER_STATUS_ENUM, MomentService, ModalService, toastr,
                 $rootScope, $document) {
        this.lodash = lodash;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.UserResource = UserResource;
        this.SiteService = SiteService;
        this.PrivilegeService = PrivilegeService;
        this.UserService = UserService;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.MomentService = MomentService;
        this.ModalService = ModalService;

        const documentClickHandler = (event) => {
            const isClickedInsideMenu = event.target.closest('.action-menu');
            if (!isClickedInsideMenu) {
                this.actions = false;
                $rootScope.$apply();
            }
        };

        $document.on('click', documentClickHandler);
    }

    $onInit () {
        this.sites = this.SiteService.getSitesByPrivileges(
            [this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_VIEW, this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE]
        );
        this.defaultFilter = {
            siteIds: this.sites.map(site => site.id),
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            expand: 'drlsWithValue,isValidExternalActivationLink',
            statuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED]
        };
        this.filter = angular.copy(this.defaultFilter);
        this.list = this.ListFactory.createWithPagination(this.UserResource.getUsers.bind(this.UserResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 50;
        this.fetchUsers();
        this.userIds = [];
    }

    fetchUsers () {
        this.list.fetch({ expand: 'drlsWithValue,isValidExternalActivationLink' }, this.defaultFilter).then((users) => {
            this.hasActiveUsers = users.filter((user) => this.UserService.isActive(user)).length;
        });
    }

    anonymizeEmployees () {
        return this.ModalService.open({
            template: `
                <modals-user-employee-anonymize-employees close="vm.$uibModalInstance.dismiss()" on-update="vm.update()"
                class="wrapper"></modals-user-employee-anonymize-employees>
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.update = this.$uibModalInstance.close;
            }
        })
        .then(() => {
            this.fetchUsers();
            this.toastr.success(this.$translate.instant('employee.Employee account deactivated'));
        });
    }

    hasUser (key) {
        return this.lodash.includes(this.userIds, key);
    }

    toggleUser (key) {
        if (this.hasUser(key)) {
            this.lodash.pull(this.userIds, key);
            this.checked = false;
        }
        else {
            this.userIds.push(key);
        }
    }

    toggleAll () {
        const activeUsers = this.list.items.filter((user) => this.UserService.isActive(user));
        this.userIds = this.checked ? activeUsers.map((user) => user.id) : [];
    }

    initBulk () {
        this.userIds = [];
        this.checked = false;
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/list/index.js